/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const eventTimelinePayoutListConfig = {
  items: [
    {
      key: 'd396eac9-fea9-448e-b093-8ed6dc3215df',
      headline: 'Kyc Doc Rejected',
      headlineBackgroundColor: '#579783',
      children: [
        {
          itemId: 'd396eac9-fea9-448e-b093-8ed6dc3215df',
          title: 'Kyc Doc Rejected',
          multiColList: {
            numberOfColumns: '2',
            data: [
              {
                title: 'By',
                subTitle: 'Sharma Pooja',
                icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/organization.png',
              },
              {
                title: 'On',
                subTitle: 'February 15, 2023 8:57 AM',
                icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/date.png',
              },
            ],
          },
          subtitle: 'February 15, 2023 8:57 AM',
        },
      ],
    },
    {
      key: 'c718d661-e9b3-4416-bae0-80facaaf02da',
      headline: 'Kyc Doc Approved',
      headlineBackgroundColor: '#579783',
      children: [
        {
          itemId: 'c718d661-e9b3-4416-bae0-80facaaf02da',
          title: 'Kyc Doc Approved',
          multiColList: {
            numberOfColumns: '2',
            data: [
              {
                title: 'By',
                subTitle: 'Sharma Pooja',
                icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/organization.png',
              },
              {
                title: 'On',
                subTitle: 'February 15, 2023 8:57 AM',
                icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/date.png',
              },
            ],
          },
          subtitle: 'February 15, 2023 8:57 AM',
        },
      ],
    },
    {
      key: '7cb70dc1-4abf-4cfd-8385-66e1f78204dc',
      headline: 'Provisional Policy Issued',
      headlineBackgroundColor: '#579783',
      children: [
        {
          itemId: '7cb70dc1-4abf-4cfd-8385-66e1f78204dc',
          title: 'Provisional Policy Issued',
          multiColList: {
            numberOfColumns: '2',
            data: [
              {
                title: 'On',
                subTitle: 'March 1, 2023 8:53 PM',
                icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/date.png',
              },
            ],
          },
          subtitle: 'March 1, 2023 8:53 PM',
        },
      ],
    },
    {
      key: 'd143eee4-00aa-46f5-a97d-c711d4c4d9dc',
      headline: 'Premium Collected',
      headlineBackgroundColor: '#579783',
      children: [
        {
          itemId: 'd143eee4-00aa-46f5-a97d-c711d4c4d9dc',
          title: 'Premium Collected',
          multiColList: {
            numberOfColumns: '2',
            data: [
              {
                title: 'By',
                subTitle: 'Kaliraj Subra Manian',
                icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/organization.png',
              },
              {
                title: 'On',
                subTitle: 'March 1, 2023 8:54 PM',
                icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/date.png',
              },
            ],
          },
          subtitle: 'March 1, 2023 8:54 PM',
        },
      ],
    },
    {
      key: '96a83a6c-db65-4525-aab8-c873e8713318',
      headline: 'Actual Policy Issued',
      headlineBackgroundColor: '#579783',
      children: [
        {
          itemId: '96a83a6c-db65-4525-aab8-c873e8713318',
          title: 'Actual Policy Issued',
          multiColList: {
            numberOfColumns: '2',
            data: [
              {
                title: 'By',
                subTitle: 'Kaliraj Subra Manian',
                icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/organization.png',
              },
              {
                title: 'On',
                subTitle: 'March 1, 2023 8:54 PM',
                icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/date.png',
              },
            ],
          },
          subtitle: 'March 1, 2023 8:54 PM',
        },
      ],
    },
  ],
  exposure:
    'https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/box_parametro.png',
  category: 'https://cdn-icons-png.flaticon.com/512/5455/5455381.png',
  dateIcon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/date.png',
  orgIcon:
    'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/organization.png',
  locationIcon:
    'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/location.png',
  wind: 'https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/wind.png',
  user: 'https://cdn.iconscout.com/icon/premium/png-256-thumb/insurance-policy-5423901-4526630.png',
};
